import qs from 'qs';

/* eslint-disable max-len */

/**
 * Build URL for the registration iframe
 * @param email
 * @param firstName
 * @param lastName
 * @param leadId
 * @param type
 * @param gender
 * @param config the application config
 * @returns {string}
 */
var buildRedirectUrl = function buildRedirectUrl(_ref) {
  var _window;
  var _ref$email = _ref.email,
    email = _ref$email === void 0 ? '' : _ref$email,
    _ref$firstName = _ref.firstName,
    firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
    _ref$lastName = _ref.lastName,
    lastName = _ref$lastName === void 0 ? '' : _ref$lastName,
    _ref$leadId = _ref.leadId,
    leadId = _ref$leadId === void 0 ? '' : _ref$leadId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type,
    _ref$gender = _ref.gender,
    gender = _ref$gender === void 0 ? '' : _ref$gender,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  // Construct an absolute URL here, as this is also used from within the
  // package which is embedded in hausgold.de, therefore relative URL does
  // not work over there
  var baseUrl = "".concat(config.url, "/registration/formwizard");
  var parameters = {
    'user[email]': email,
    'user[first_name]': firstName,
    'user[last_name]': lastName,
    'user[gender]': gender,
    'lead[id]': leadId,
    'lead[type]': type
  };
  if ((_window = window) !== null && _window !== void 0 && (_window = _window.ga) !== null && _window !== void 0 && _window.loaded) {
    window.ga(function (tracker) {
      parameters.clientId = tracker.get('clientId');
    });
  }
  if (!firstName) delete parameters['user[first_name]'];
  if (!lastName) delete parameters['user[last_name]'];
  if (!gender) delete parameters['user[gender]'];
  var urlEncodedParameters = qs.stringify(parameters);
  return "".concat(baseUrl, "?").concat(urlEncodedParameters);
};
export { buildRedirectUrl as default };